<div *ngIf="enableLayoutMenu">
  <app-shared-layout role="presentation"> </app-shared-layout>
</div>
<div class="container">
<div class="simulation-dashboard-section change-password-container">
<section>
  <div class="login_wraper" role="form" aria-labelledby="changePasswordHeading">
    <div class="mid_container">
      <div class="mid_container_inner">
        <div class="login_section">
          <h1 class="heading-level-2 blue-color" tabindex="-1">Change Password</h1>
          <div class="row">
          <form
          class="form-horizontal form-style1 mb-10 mt-0"
          #courseForm="ngForm"
          (ngSubmit)="updatePasssword()"
          aria-labelledby="changePasswordHeading"
          >
            <div class="form-group">
              <div class="col-xs-12 col-sm-12">
                <div class="input-group full-width">
                  <!-- <span class="input-group-addon"
                    ><i class="fa fa-key" aria-hidden="true"></i
                  ></span> -->
                  <input
                    type="password"
                    class="form-control"
                    id="name"
                    placeholder=""
                    [(ngModel)]="oldpassword"
                    name="name"
                    id="oldpassword"
                    title="Current Password" 
                    aria-label="Current Password"
                    aria-required="true"
                  />
                  <label for="name">Current Password <span class="required">*</span></label>
                  <img
                    class="eye_img icon"
                    src="assets/images/eye_password.svg"
                    id="oldpassword_img"
                    alt="Show current password"
                    (click)="revealPassword('oldpassword', 'oldpassword_img')"
                    tabindex="0"
                    aria-label="Show current password"
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="col-xs-12 col-sm-12">
                <div class="input-group full-width">
                  <!-- <span class="input-group-addon"
                    ><i class="fa fa-key" aria-hidden="true"></i
                  ></span> -->
                  <input
                    type="password"
                    class="form-control"
                    id="name"
                    placeholder=""
                    [(ngModel)]="newpassword"
                    name="name"
                    id="newpassword"
                    title="New Password" 
                    aria-label="New Password"
                    aria-required="true"
                  />
                  <label for="name">New Password <span class="required">*</span></label>
                  <img
                    class="eye_img icon"
                    src="assets/images/eye_password.svg"
                    id="newpassword_img"
                    alt="Show New password"
                    (click)="revealPassword('newpassword', 'newpassword_img')"
                    tabindex="0"
                    aria-label="Show new password"
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="col-xs-12 col-sm-12">
                <div class="input-group full-width">
                  <!-- <span class="input-group-addon"
                    ><i class="fa fa-key" aria-hidden="true"></i
                  ></span> -->
                  <input
                    type="password"
                    class="form-control"
                    id="email"
                    placeholder=""
                    [(ngModel)]="newpasswordconfirm"
                    name="email"
                    id="newpasswordconfirm"
                    title="Confirm New Password" 
                    aria-label="Confirm New Password"
                    aria-required="true"
                  />
                  <label for="email">Confirm New Password <span class="required">*</span></label>
                  <img
                    class="eye_img icon"
                    src="assets/images/eye_password.svg"
                    id="confirmpassword_img"
                    alt="Show confirm password"
                    (click)="
                      revealPassword(
                        'newpasswordconfirm',
                        'confirmpassword_img'
                      )
                    "
                    tabindex="0"
                    aria-label="Show comfirm password"
                  />
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12">
              <p class="pwd_hint full-width" aria-live="polite" tabindex="0">
                Your password cannot contain your email address, first name, or
                last name. It must be minimum of 8 characters in length,
                containing at least one upper case letter, one lower case letter,
                one number, and one special character.
              </p>
            </div>
            <div class="button-container button-container-center pr-15 pl-15">
            <button
            *ngIf="!enableCancel"
              (click)="logout()"
              class="button-style1 login-button mr-15"
              tabindex="0"
              role="button"
              >Cancel</button
            >

            <button
            *ngIf="enableCancel"
              (click)="HomePage()"
              class="button-style1 login-button mr-15"
              tabindex="0"
              role="button"
              >Cancel</button
            >
            <button
            class=" login-button check_valid button-style1"
            type="submit"
          >
            Change Password
          </button>
            </div>           


            <div *ngIf="errorMsg" class="errormsg pr-15 pl-15" role="alert">
              {{ errorMsg }}
            </div>
          </form>
        </div>
      </div>
      </div>
    </div>
  </div>
</section>
</div>
</div>